import { useEffect, useState } from "react";
import { toast } from "sonner";
import { NotebookPen, Trash2 } from "lucide-react";
import { http, formatApiError } from "@/lib/api";
import { useProfile } from "@/context/ProfileContext";

export const BabyJournal = ({ babyId, name }) => {
  const { profile } = useProfile();
  const [items, setItems] = useState(null);
  const [text, setText] = useState("");
  useEffect(() => { http.get(`/babies/${babyId}/journal`).then((r) => setItems(r.data)).catch(() => setItems([])); }, [babyId]);
  const add = async (e) => {
    e.preventDefault();
    try { const r = await http.post(`/babies/${babyId}/journal`, { text }); setItems((x) => [r.data, ...x]); setText(""); } catch (err) { toast.error(formatApiError(err)); }
  };
  const del = async (id) => {
    try { await http.delete(`/babies/${babyId}/journal/${id}`); setItems((x) => x.filter((i) => i.id !== id)); } catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <section className="rounded-3xl bg-[#FBF8F1] border border-[#E6DEC3] p-6" data-testid="baby-journal">
      <h3 className="font-display text-2xl text-[#2C4A3E] flex items-center gap-2"><NotebookPen className="w-5 h-5 text-[#C87D53]" />{profile?.role === "daycare" ? "Daily notes" : "Parent journal"}</h3>
      <form onSubmit={add} className="mt-4 space-y-2">
        <textarea value={text} onChange={(e) => setText(e.target.value)} maxLength={2000} rows={3} required placeholder={`A moment with ${name} you want to remember…`} data-testid="baby-journal-input"
          className="w-full px-4 py-3 rounded-2xl bg-white border border-[#D6CDB4] text-sm focus:outline-none focus:border-[#2C4A3E]" />
        <button disabled={!text.trim()} data-testid="baby-journal-save" className="px-5 py-2 rounded-full bg-[#C87D53] text-white text-sm disabled:opacity-50">Save memory</button>
      </form>
      <ul className="mt-4 space-y-2 max-h-[320px] overflow-y-auto">
        {items?.map((i) => (
          <li key={i.id} className="flex gap-3 rounded-2xl bg-white border border-[#EEE8DA] px-4 py-3" data-testid={`baby-journal-entry-${i.id}`}>
            <span className="flex-1 text-sm text-stone-700 whitespace-pre-wrap break-words">{i.text}<span className="block text-[11px] text-stone-400 mt-1">{new Date(i.created_at).toLocaleDateString([], { month: "short", day: "numeric", year: "numeric" })}{i.by ? ` · ${i.by}` : ""}{i.daycare && <span className="ml-1.5 px-1.5 py-0.5 rounded-full bg-[#EEF3EF] text-[#2E5A45]" data-testid={`baby-journal-daycare-${i.id}`}>Daycare note</span>}</span></span>
            {(!i.author_id || i.author_id === profile?.id) && <button onClick={() => del(i.id)} aria-label="Delete memory" data-testid={`baby-journal-delete-${i.id}`} className="p-1.5 h-fit rounded-full hover:bg-[#F1EADB] text-stone-500"><Trash2 className="w-4 h-4" /></button>}
          </li>))}
        {items && !items.length && <li className="text-sm text-stone-500" data-testid="baby-journal-empty">No memories yet.</li>}
      </ul>
    </section>
  );
};
